import axios from 'axios'
import {SearchUrlParamBuilder} from "@/core/utils";

class PedidoApiClient {
	URL_PATH = 'api/pedido'

	async calcularTotalPedido(idPedido) {
		return await axios.get(`${this.URL_PATH}/${idPedido}/total`)
	}

	async buscarInformacoesPorIdPedido(idPedido) {
		return await axios.get(`${this.URL_PATH}/${idPedido}`)
	}

	async salvarPedido(salvarPedidoInput) {
		return await axios.put(`${this.URL_PATH}/${salvarPedidoInput.idPedido}`, salvarPedidoInput)
	}

	async salvarNumeroPedido(salvarNumeroPedidoInput) {
		return await axios.put(
			`${this.URL_PATH}/${salvarNumeroPedidoInput.idPedido}/numeroPedido`,
			salvarNumeroPedidoInput,
		)
	}

	async salvarPedidoComItensEmRascunho(salvarItensEmRascunhoPedidoInput) {
		return await axios.put(
			`${this.URL_PATH}/${salvarItensEmRascunhoPedidoInput.idPedido}/alterarItensParaEmElaboracao`,
			salvarItensEmRascunhoPedidoInput,
		)
	}

	async removerItensEmRascunho(removerItensEmRascunhoPedidoInput) {
		return await axios.delete(
			`${this.URL_PATH}/${removerItensEmRascunhoPedidoInput.idPedido}/removerItensEmRascunho`,
		)
	}

	async excluirPedido(idPedido) {
		return await axios.delete(`${this.URL_PATH}/${idPedido}`)
	}

	async autorizarPedido(idPedido) {
		return await axios.put(`${this.URL_PATH}/${idPedido}/autorizar`)
	}

	async concluirPedido(idPedido) {
		return await axios.put(`${this.URL_PATH}/${idPedido}/concluir`)
	}

	async efetivarPedido(idPedido) {
		return await axios.put(`${this.URL_PATH}/${idPedido}/efetivar`)
	}

	async naoAutorizarPedido(idPedido) {
		return await axios.put(`${this.URL_PATH}/${idPedido}/nao-autorizar`)
	}

	async buscarOrgaosDoUsuario(idAta) {
		return axios.get(`api/pedido/unidade-organizacional/doUsuario/${idAta}`)
	}

	async enviarPedidoIntegracao(idPedido) {
		await axios.post(`${this.URL_PATH}/${idPedido}/integracao/enviar`)
	}

	async baixarRelatorioPrevio(idPedido) {
		return await axios.get(`${this.URL_PATH}/relatorio-previo/${idPedido}/baixar`, {
			responseType: 'arraybuffer',
		})
	}

	async buscarPedidosPorFiltro(objParam, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${this.URL_PATH}/porFiltro`,
			filters: objParam,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()

		return await axios.get(url)
	}

	async buscarPedidoOrgaos() {
		return await axios.get(`${this.URL_PATH}/porFiltro/buscarOrgaos`)
	}

	async buscarAlmoxarifados(idPedido) {
		return axios.get(`api/pedido/${idPedido}/almoxarifados`)
	}

	async buscarEspeciesDocumentaisProtocolo() {
		return axios.get('api/especies-documentais/ativas')
	}

	async protocolarPedido(idPedido, dadosProtocolo) {
		return axios.post(`${this.URL_PATH}/${idPedido}/gerar-protocolo`, dadosProtocolo)
	}
}

export default new PedidoApiClient()
